import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {AddressData, ContractData, TableBySerialData} from "./types";
import zoomPlugin from "chartjs-plugin-zoom";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  zoomPlugin,
);

const ChartBarAddress: React.FC<AddressData> = ({
  verticalSize,
  addreses,
}) => {
  const data = [...addreses];

  const labels = data.map((el) => el.name);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: "Адреса",
        data: data.map((i) => i.summary_problems),
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        barPercentage: 1,
        categoryPercentage: 0.7,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      zoom: {
        zoom: {
          mode: "x" as "x" | "y" | "xy",
          wheel: {
            enabled: true,
          },
          pinch: {
            enabled: true,
          },
        },
      },
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: "Статистика обращений по уровню критичности и адресу",
      },
      tooltip: {
        callbacks: {
          title: (tooltipItems: any) => {
            return tooltipItems[0].label;
          },
          label: (tooltipItem: any) => {
            const dataPoint = tooltipItem.raw;
            return `Обращения: ${dataPoint}`;
          },
          afterLabel: (tooltipItem: any) => {
            const item = data.find((el) => el.name === tooltipItem.label);
            if (!item) return;

            return [
              `Низкий: ${item.problem_lvl_low}`,
              `Средний: ${item.problem_lvl_mid}`,
              `Стандартный: ${item.problem_lvl_standart}`,
              `Высокий: ${item.problem_lvl_high}`,
              `Критический: ${item.problem_lvl_critical}`,
            ];
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: verticalSize,
      },
    },
  };

  return <Bar data={chartData} options={options} />;
};

export default ChartBarAddress;
